module.exports = __webpack_public_path__ + "static/media/rooster.ad29f7b9.png";